module.exports = __webpack_public_path__ + "static/media/uplawwhite.b74f09f0.png";